import logo from './logo.svg';
import './App.css';
import React from 'react';
import {
  Link,
  Outlet
} from "react-router-dom";
import backgroundImage from './imgs/bg.jpg';
import icon from './imgs/icon.png'
export function App() {
  return (
    <div className="App">
      <div className="bg"
      style={{
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      height: '100vh',
    }}></div>
      <div className="filter"></div>
      
      <div className="App-body">
        <Outlet />
      </div>
      <header className="App-header">
        <div className="icon-container">
        <Link to="/" className="icon">
          <img src={icon} />
        </Link>
        </div>

      </header>
    </div>
  );
}

const Nav = ()=> (
<div className="App__Nav">
    <Link to="wedding" className="c1">Wedding Celebration</Link>
    <Link to="wedding-gifts" className="c2">Wedding Gifts</Link>
   
</div>
  )

const Home = () => (
<div className="home">
    
      </div>
  )

export function Lander() {
  return(
    <div className="lander">
      <h1>Jem and Tara</h1>
      <Nav />
    </div>
    )
}

export function Travel() {
  return(
    <div className="travel">
      <h1>The Adventures of Jem and Tara</h1>
      <h2>National Park Adventures</h2>
      <h3>Acadia National Park</h3>
      <h3>Shenandoah National Park</h3>
      <h2>Other Adventures</h2>
      <h3>Italy</h3>
      <Home />
    </div>
    )
}

export function Dinner() {
  const d = Date.now()

  return (
    <div className="dinner">
      <h1>Dinner 12/9/2024</h1>
      <h2>Appetizer</h2>
      <p>Pastrami Style Red Pearl Onions</p>
      <h2>Main Course</h2>
      <p>Creamed White Pearl Onions</p>
      <p>Chicken Cutlets</p>
      <h2>Dessert</h2>
      <p>Sweet Potato Mash</p>
      <Home />
    </div>

    )
}

export function Private() {
  const privatePW = React.createRef(null)
  return (
    <div className="private">
      <div className="password">
        <p>Who are you?</p>
        <input ref={privatePW} />
        <button>Submit</button>
      </div>
      <Home />
    </div>
    )
}

export function Wedding() {

  return (
    <div className="wedding">
      <h1>Wedding Celebration</h1>
      <div className="section">
        <p>If you received an invitation and RSVP'd, we can't wait to see you! Please see your invitation for more details regarding the time and location of the party.</p>
        <h2>Overview</h2>
        <p>This is a backyard wedding celebration. We will be married BEFORE the party. There will be no ceremony, just the fun parts: drinking, eating and dancing!</p>
        <h2>Dress Code</h2>
        <p>There is no dress code, but something beachy and breezy is perfect. It will probably be hot and there will be a pool! </p>

      </div>
      <Home />
    </div>
    )
}
export function Gifts() {

  return (
    <div className="wedding-gifts">
      <h1>Wedding Gifts</h1>
      <div className="section">
        <p>We are travelling to Italy for our Honeymoon and then planning to start our family. Instead of providing a gift registry, we ask that you donate to either our Honeymoon Fund, or our Baby Fund. Not giving a gift is also okay.</p>
        <a href="https://donate.stripe.com/8x25kCgL32b870ah0ueQM00" target="_blank" rel="noopener noreferrer">
          <button>Honeymoon Fund</button>
        </a>
        <a href="https://donate.stripe.com/8x2dR87atcPM2JU11weQM01" target="_blank" rel="noopener noreferrer">
          <button>Baby Fund</button>
        </a>
      </div>
      <Home />
    </div>
    )
}


export function Events() {
  return (
    <div className="events">
      <h1>Upcoming Events</h1>
      <div className="upcoming">
        <div className="event">Godfather Marathon</div>
        <div className="event">Rick and Morty Marathon</div>
      </div>
      <Home />
    </div>
    )
}



